import {
  Directive,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { distinctUntilChanged, filter, Subscription } from 'rxjs';

@Directive({
  selector: '[interfaceInputDigits]',
  standalone: false,
})
export class InputDigitsDirective implements OnInit, OnDestroy {
  private ngControl = inject(NgControl, { self: true });

  sub!: Subscription;

  @Output() valueChanges = new EventEmitter<string>();

  ngOnInit(): void {
    this.sub = this.ngControl.valueChanges
      ?.pipe(
        distinctUntilChanged(),
        filter((v) => !!v),
      )
      .subscribe((value) => {
        const digits = value.replace(/\D/g, '');
        this.ngControl.control?.setValue(digits);
        if (digits) {
          this.valueChanges.emit(digits);
        }
      }) as Subscription;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
